import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersists from 'vuex-persist'

Vue.use(Vuex);

const persist = new VuexPersists({
  storage: localStorage
});

const store = new Vuex.Store({
  state: {
    token: '',
    customerNumber: '',
    initFinished: false,
    customerNumbers: [],
  },
  mutations: {
    token (state, value) {
      state.token = value;
    },
    customerNumber (state, value) {
      state.customerNumber = value;
    },
    initFinished (state, value) {
      state.initFinished = value;
    },
    customerNumbers (state, value) {
      state.customerNumbers = value;
    },
  },
  getters: {
    getToken: (state) => () => {
      return state.token;
    },
    token: (state) => () => {
      return state.token;
    },
    customerNumber: (state) => () => {
      return state.customerNumber;
    },
    initFinished: (state) => () => {
      return state.initFinished;
    },
    customerNumbers: (state) => () => {
      return state.customerNumbers;
    },
  },
  plugins: [persist.plugin]
});

export default store